import React from "react";

const ImageSlider = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.25 4.5H6.75C6.33579 4.5 6 4.83579 6 5.25V15.75C6 16.1642 6.33579 16.5 6.75 16.5H20.25C20.6642 16.5 21 16.1642 21 15.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.125 8.8125C16.6428 8.8125 17.0625 8.39277 17.0625 7.875C17.0625 7.35723 16.6428 6.9375 16.125 6.9375C15.6072 6.9375 15.1875 7.35723 15.1875 7.875C15.1875 8.39277 15.6072 8.8125 16.125 8.8125Z"
      fill="currentColor"
    />
    <path
      d="M6 12.0648L9.59437 8.46948C9.66403 8.39974 9.74675 8.34443 9.83779 8.30668C9.92884 8.26894 10.0264 8.24951 10.125 8.24951C10.2236 8.24951 10.3212 8.26894 10.4122 8.30668C10.5033 8.34443 10.586 8.39974 10.6556 8.46948L15.3103 13.1251L17.7188 10.7195C17.8594 10.5789 18.0501 10.5 18.2489 10.5C18.4477 10.5 18.6384 10.5789 18.7791 10.7195L21 12.9432"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 16.5V18.75C18 18.9489 17.921 19.1397 17.7803 19.2803C17.6397 19.421 17.4489 19.5 17.25 19.5H3.75C3.55109 19.5 3.36032 19.421 3.21967 19.2803C3.07902 19.1397 3 18.9489 3 18.75V8.25C3 8.05109 3.07902 7.86032 3.21967 7.71967C3.36032 7.57902 3.55109 7.5 3.75 7.5H6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ImageSlider;
